import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import Scripts from "./Script";
import { Button, Modal, Row, Col } from "react-bootstrap";
import storage from "../../../../Storage";
import RangeCredit from "../../../Components/Game/Addons";
import Engine from "../Engine";
import { gameCoin } from "../../../../actions/gameCoin";
import { setWallet } from "../../../../actions/gameWallet";
import { setWinnerText, setMeToGame } from "../../../../actions/crashGame";
import { Event, __, isValidNumber, forceSatoshiFormat, User, wait, Game, sendNotfication, randomString } from "../../../../Helper";
import Menus from "./Menus";
import AutoBet from "./AutoBet";
import C from "../../../../Constant";
import './style2.css';

class ManualBet extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            engine: null,
            buttonText: 'Bet',
            buttonType: 'btn-bet',
            barType: 'next-round',
            inputDisabled: false,
            buttonProgress: null,
            gameStatus: null,
            clicked: false,
            added: false,
            holding: false,
            showNext: true,
            payout: forceSatoshiFormat(storage.getKey('odd') ? storage.getKey('odd') : 3000.00),
            // payout: forceSatoshiFormat(storage.getKey('odd') ? storage.getKey('odd') : 5.00),
            token: storage.getKey('token') ? storage.getKey('token') : null,
            hotkey: storage.getKey('hotkey') ? storage.getKey('hotkey') : "OFF",
            auto: false,
            online_users: 0,
            bid: '',
            our_bid: '',
            activeTab: 'bet',
            activeTab2: 'bet2',
            amount: parseFloat(storage.getKey('lam')) || 10.00,
            secondBetAmount: parseFloat(storage.getKey('lam2')) || parseFloat(storage.getKey('lam')) || 10.00,
            im_in_game_1: false,
            im_in_game_2: false,
            isCashingOut1: false,
            isCashingOut2: false,
            buyDisabled: false,
            buyButtonText: 'Buy',
            sellButtonText: 'Sell',
            sellButtonType: 'btn-bet',
            sellDisabled: false,
            showSellAmount: true,
            isPlacingBet1: false,
            isPlacingBet2: false,
            buyTriggered: false,
            isLoadingBet1: false,
            isLoadingBet2: false,
            countdown1: null,
            countdown2: null,
            showWinNotification: false,
            winAmount: 0
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleBuy = this.handleBuy.bind(this);
        this.handleSell = this.handleSell.bind(this);
        this.setBet = this.setBet.bind(this);
        this.wrapperRef = React.createRef();
        this.buyRef = React.createRef();
        this.lastClickTime = 0;
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
        const engine = Engine

        this.setState({ engine: engine })

        //Load Coin From Redux
        this.props.gameCoin();

        window.addEventListener('keypress', this.handleHotKey.bind(this));

        // Game Event
        engine.trigger.on("game_status", (data) => this.checkStatus(data));

        engine.trigger.on("waiting_crash", () => this.checkWaitingGame());
        engine.trigger.on("busted_crash", () => this.checkBustedGame());
        engine.trigger.on("started_crash", () => this.checkStartedGame());

        // User Event
        engine.trigger.on("play_crash", data => this.handlePlay(data));
        engine.trigger.on("finish_crash", data => this.handleFinish(data));
        engine.trigger.on("error_crash", data => this.handleError(data));
        engine.trigger.on("stop_playing", () => this.stopManual());
        engine.trigger.on("auto_bet", data => this.handleAuto(data));
    }

    componentWillUnmount() {
        this._isMounted = false;
        window.removeEventListener('keypress', this.handleHotKey.bind(this));
    }

    handleClickOutside(event) {
        let value = parseFloat(this.state.payout);

        if (value < 1.01)
            value = 3.00;

        if (isNaN(value))
            value = 3.00;

        if (value > 3000)
            value = 3000;

        this.setState({ payout: parseFloat(value).toFixed(2) });

        var amount = this.wrapperRef.current.value;

        if (amount === '') {
            amount = 10.00;
            this.setState({ amount: 10.00, secondBetAmount: 10.00 });
            storage.setKey('lam', 10.00);
            storage.setKey('lam2', 10.00);
        }

        if (parseFloat(amount) < 10.00) {
            amount = 10.00;
            this.setState({ amount: forceSatoshiFormat(10.00), secondBetAmount: forceSatoshiFormat(10.00) });
            storage.setKey('lam', forceSatoshiFormat(10.00));
            storage.setKey('lam2', forceSatoshiFormat(10.00));
        }

        if (parseFloat(amount) > 10000.00) {
            amount = 10000.00;
            this.setState({ amount: forceSatoshiFormat(10000.00), secondBetAmount: forceSatoshiFormat(10000.00) });
            storage.setKey('lam', forceSatoshiFormat(10000.00));
            storage.setKey('lam2', forceSatoshiFormat(10000.00));
        }

        if (parseFloat(amount) <= 0) {
            amount = 10.00;
            this.setState({ amount: forceSatoshiFormat(10.00), secondBetAmount: forceSatoshiFormat(10.00) });
            storage.setKey('lam', forceSatoshiFormat(10.00));
            storage.setKey('lam2', forceSatoshiFormat(10.00));
        }
        else {
            if (amount === "NaN") amount = 10.00;
            this.setState({ amount: forceSatoshiFormat(amount), secondBetAmount: forceSatoshiFormat(amount) });
            storage.setKey('lam', forceSatoshiFormat(amount));
            storage.setKey('lam2', forceSatoshiFormat(amount));
        }
    }

    handleInputChange(event) {
        let target = event.target;
        let value = target.value;
        let name = target.name;

        if (name === 'amount') {
            if (!isValidNumber(value)) return;
        }

        if (name === 'payout') {
            storage.setKey('odd', value);
            if (value >= 3000) {
                return;
            }
            else if (value === '') {
                sendNotfication("Please Input Minimum Cashout Value of 1.01", 'info', 'top-center');
            }
        }

        if (name === 'amount') {
            storage.setKey('lam', value);
            // Sync secondBetAmount if update is from the main amount input
            this.setState({ amount: value, secondBetAmount: value });
            storage.setKey('lam2', value);
        } else if (name === 'secondBetAmount') {
            storage.setKey('lam2', value);
            this.setState({ [name]: value });
        } else {
            this.setState({ [name]: value });
        }
    }

    stopManual() {
        this.setState({ started: false, buyButtonText: 'Buy', inputDisabled: false });
        this.setDefaultButton();
    }

    checkStatus(data) {
        if (this._isMounted) {
            // console.log("Status Data | " + JSON.stringify(data));
            switch (data.status) {
                case 'waiting':
                    this.checkWaitingGame();
                    break;
                case 'started':
                    this.checkStartedGame();
                    break;
                case 'busted':
                    this.checkBustedGame();
                    break;
                default:
            }
        }
    }

    handleAuto = (data) => {
        if (this._isMounted) {
            let { amount, payout } = this.state;
            console.log(amount + " - " + payout);

            if (!payout) return alert('payout is empty.');
            if (!amount) return alert('amount is empty.');

            this.setState({ amount: amount, secondBetAmount: amount, payout: payout, auto: true, buyButtonText: "Automatic" });
            storage.setKey('lam', amount);
            storage.setKey('lam2', amount);

            this.setState({
                added: false,
                inputDisabled: true,
                buyDisabled: true
            });

            if (this.state.gameStatus === 'started') {
                this.holdBet();
            }
            else if (this.state.gameStatus === 'waiting') {
                this.setBet();
            }
        }
    };

    handleError(data) {
        if (this._isMounted) {
            // if (data.our_gid == '0') {

            console.log("Error Data: ", data);

            this.props.setMeToGame(false);

            this.setState({ holding: false, added: false, inputDisabled: false, buyDisabled: false, isPlacingBet: false, buyTriggered: false });

            if (this.buttonProgressInterval) {
                clearInterval(this.buttonProgressInterval);
                this.buttonProgressInterval = null;
            }
            this.setState({ buttonProgress: null }); // Keep state update for potential UI needs, though logic relies on class prop

            this.setDefaultButton();

            if (!__.isUndefined(data.code)) {
                if (data.code === 'credit')
                    this.props.setWallet(true, data.uid);
            }

            this.setState({ clicked: false })
            sendNotfication(data.message, 'danger', 'top-center');
            // }
        }
    }

    setDefaultButton = () => {
        if (this._isMounted) {
            if (this.buttonProgressInterval) {
                clearInterval(this.buttonProgressInterval);
                this.buttonProgressInterval = null;
            }
            this.setState({ buttonProgress: null });

            // Reset synchronous cashout guards
            this._cashingOut1 = false;
            this._cashingOut2 = false;

            this.setState({
                added: false,
                holding: false,
                inputDisabled: false,
                buttonType: 'btn-bet',
                buttonText: "Bet",
                barType: "next-round",
                showNext: true,
                im_in_game_1: false,
                im_in_game_2: false,
                isCashingOut1: false,
                isCashingOut2: false,
                buyDisabled: false,
                buyButtonText: this.state.auto ? "Automatic" : 'Buy',
                sellButtonText: 'Sell',
                sellButtonType: 'btn-bet',
                sellDisabled: false,
                showSellAmount: true,
                isPlacingBet1: false,
                isPlacingBet2: false,
                buyTriggered: false
            });
        }
    };

    setWaitingButton = () => {
        if (this._isMounted) {
            this.setState({
                added: true,
                inputDisabled: true,
                sellButtonType: 'btn-bet-success-waiting',
                barType: "next-round",
                showNext: true,
                sellDisabled: true,
                showSellAmount: false
            });
        }
    };

    setOutButton = () => {
        if (this._isMounted) {
            this.setState({
                inputDisabled: false,
                sellButtonType: 'btn-bet-success',
                barType: "next-round",
                showNext: true,
                im_in_game: false,
                sellDisabled: true,
                showSellAmount: false
            });
        }
    };

    setBet(slot = 1) {
        if (this._isMounted) {
            if (slot === 1) {
                if (this.state.isPlacingBet1) return;
                this.setState({ clicked: true, im_in_game_1: true, buyDisabled: true, isPlacingBet1: true });
            } else {
                if (this.state.isPlacingBet2) return;
                this.setState({ clicked: true, im_in_game_2: true, sellDisabled: true, isPlacingBet2: true });
            }

            let { engine, amount, payout, token, secondBetAmount } = this.state;
            let { bid } = this.props;

            // Get current multiplier (exact point where user started trade)
            const currentMult = parseFloat(Game['current_amount']) || 1.00;

            engine.coin = 'kshs';
            engine.token = token;
            engine.amount = slot === 1 ? amount : (secondBetAmount || amount);
            engine.payout = parseInt(payout * 100) * parseInt(engine.amount);
            engine.odd = currentMult; // Set to exact entry point instead of payout configuration
            engine.bid = bid;

            if (slot === 1) {
                engine.play();
            } else {
                engine.play2();
            }
        }
    }

    cashOut(slot = 1) {
        if (this._isMounted) {
            // Synchronous guard against double cashout
            if (slot === 1 && this._cashingOut1) return;
            if (slot === 2 && this._cashingOut2) return;
            if (slot === 1) this._cashingOut1 = true;
            if (slot === 2) this._cashingOut2 = true;

            let { engine } = this.state;
            let currentOdd = Game['current_amount'];

            console.log('[CASHOUT] Firing cashOut for slot', slot, 'at odd', currentOdd);

            if (slot === 1) {
                this.setState({
                    im_in_game_1: false,
                    isCashingOut1: true,
                    buyDisabled: false
                });
                engine.finish(currentOdd);
            } else {
                this.setState({
                    im_in_game_2: false,
                    isCashingOut2: true,
                    sellDisabled: false
                });
                engine.finish2(currentOdd);
            }
        }
    }

    handlePlay(data) {
        console.log("play Data | " + JSON.stringify(data));

        if (this._isMounted) {
            if (data.token === this.state.token) {
                this.props.setMeToGame(true);

                // Clear spinner when entry is confirmed
                if (data.bType === 'BUY') {
                    this.setState({ isLoadingBet1: false });
                } else if (data.bType === 'SELL') {
                    this.setState({ isLoadingBet2: false });
                }

                // Add trade to engine active trades for graph marking
                // Using server-confirmed "odd" value and "bType"
                if (this.state.engine) {
                    const newTrade = {
                        id: randomString(8),
                        amount: data.amount,
                        entryMult: parseFloat(data.odd),
                        entryTime: Date.now(),
                        expiryTime: Date.now() + 10000,
                        slot: data.bType === 'BUY' ? 1 : 2
                    };
                    this.state.engine.activeTrades.push(newTrade);
                }

                // Initialize bet start time if entering during active game
                if (this.state.gameStatus === 'started') {
                    if (data.bType === 'BUY' && !this.betStartTime1) {
                        this.betStartTime1 = Date.now();
                    } else if (data.bType === 'SELL' && !this.betStartTime2) {
                        this.betStartTime2 = Date.now();
                    }
                }

                // Start tracking if not already
                if (this.state.gameStatus === 'started') {
                    this.startTimerInterval();
                }
            }
        }
    }

    handleFinish(data) {
        if (this._isMounted) {
            if (data.token === this.state.token) {
                // Determine which slot finished based on channel
                // If channel is not present (fallback), we might need to rely on inference, 
                // but we trust the engine emits it as validated in planning.
                const isBuy = data.channel === 'BUY';
                const isSell = data.channel === 'SELL';

                setTimeout(() => {
                    let updateState = {};

                    if (isBuy) {
                        updateState.im_in_game_1 = false;
                        updateState.isCashingOut1 = false;
                        updateState.buyDisabled = false;
                        updateState.buyButtonText = this.state.auto ? "Automatic" : 'Buy';
                        this.betStartTime1 = null;
                        this._cashingOut1 = false; // Reset synchronous guard
                        // Remove from graph indicators
                        if (this.state.engine) {
                            this.state.engine.activeTrades = this.state.engine.activeTrades.filter(t => t.slot !== 1);
                        }
                    }

                    if (isSell) {
                        updateState.im_in_game_2 = false;
                        updateState.isCashingOut2 = false;
                        updateState.sellDisabled = false;
                        updateState.sellButtonText = 'Sell';
                        this.betStartTime2 = null;
                        this._cashingOut2 = false; // Reset synchronous guard
                        // Remove from graph indicators
                        if (this.state.engine) {
                            this.state.engine.activeTrades = this.state.engine.activeTrades.filter(t => t.slot !== 2);
                        }
                    }

                    // Apply independent updates
                    this.setState(updateState);

                    // Check effective state after this update
                    // We use the derived values because setState is async
                    const remainingInGame1 = isBuy ? false : this.state.im_in_game_1;
                    const remainingInGame2 = isSell ? false : this.state.im_in_game_2;

                    // Only strict cleanup if BOTH are finished
                    if (!remainingInGame1 && !remainingInGame2) {
                        this.props.setMeToGame(false);

                        // Stop timer
                        if (this.buttonProgressInterval) {
                            clearInterval(this.buttonProgressInterval);
                            this.buttonProgressInterval = null;
                        }

                        // Reset general state
                        this.setState({
                            buttonProgress: null,
                            inputDisabled: false,
                            added: false,
                            holding: false,
                            buyTriggered: false
                        });
                    }

                    if (data.won > 0) {
                        // Trigger floating profit popup on canvas
                        this.state.engine.trigger.emit('visual_profit', {
                            mult: parseFloat(data.odd),
                            amount: data.won + data.amount
                        });
                        // sendNotfication("You Have Won Kes " + forceSatoshiFormat(data.won + data.amount), 'success', 'top-center');
                        this.setState({
                            showWinNotification: true,
                            winAmount: forceSatoshiFormat(data.won + data.amount)
                        });

                        // Auto-hide after 5 seconds
                        setTimeout(() => {
                            if (this._isMounted) {
                                this.setState({ showWinNotification: false });
                            }
                        }, 5000);
                    } else {
                        sendNotfication("You Have Lost Kes " + forceSatoshiFormat(data.amount), 'danger', 'top-center');
                    }
                }, 150);
            }
        }
    }

    checkWaitingGame() {
        if (this._isMounted) {
            this.props.setWinnerText('');

            this.setColor = 'text-success';
            this.setState({ gameStatus: 'waiting' });

            // Reset start time for the next round only if no active bet
            if (!this.state.im_in_game_1) {
                this.betStartTime1 = null;
            }
            if (!this.state.im_in_game_2) {
                this.betStartTime2 = null;
            }

            let { engine, online_users } = this.state;
            // ... online users logic ...
            let today = new Date()
            let curHr = today.getHours()
            if (curHr < 10) online_users = this.getRandomInt(100, 120);
            else if (curHr < 12) online_users = this.getRandomInt(130, 150);
            else if (curHr < 18) online_users = this.getRandomInt(290, 310);
            else if (curHr < 20) online_users = this.getRandomInt(315, 350);
            else online_users = this.getRandomInt(355, 400);
            this.setState({ online_users: online_users });

            if (this.state.holding) {
                this.setState({ holding: false, buyDisabled: false, sellDisabled: false, isPlacingBet1: false, isPlacingBet2: false, buyTriggered: false });
                if (this.state.holdingSlot === 1) this.placeBet(1);
                else if (this.state.holdingSlot === 2) this.placeBet(2);
                else { this.placeBet(1); this.placeBet(2); } // If both
            } else if (!this.state.added && !this.state.im_in_game_1 && !this.state.im_in_game_2) {
                this.setDefaultButton();
            }
        }
    }

    checkStartedGame() {
        if (this._isMounted) {
            this.setState({ gameStatus: 'started', online_users: this.state.online_users });
            let { im_in_game_1, im_in_game_2 } = this.state;
            let { engine, online_users } = this.state;

            let coin = 'kshs';
            let amount = engine.amount

            let today = new Date()
            let curHr = today.getHours()

            if (curHr < 10) {
                online_users = this.getRandomInt(100, 120);
            }
            else if (curHr < 12) {
                online_users = this.getRandomInt(130, 150);
            } else if (curHr < 18) {
                online_users = this.getRandomInt(290, 310);
            } else if (curHr < 20) {
                online_users = this.getRandomInt(315, 350);
            }
            else {
                online_users = this.getRandomInt(355, 400);
            }

            this.setState({ gameStatus: 'started', online_users: online_users });

            // Timer logic runs for all bets when player is in game
            // Check if player has active positions
            if (im_in_game_1 || im_in_game_2 || this.state.clicked) {
                // Only start tracking if we haven't already
                if (this.buttonProgressInterval) return;

                // Use the new startTimerInterval function
                this.startTimerInterval();
            }
        }
    }

    startTimerInterval() {
        if (this._isMounted) {
            // Clear any existing interval first
            if (this.buttonProgressInterval) {
                clearInterval(this.buttonProgressInterval);
                this.buttonProgressInterval = null;
            }

            let { engine } = this.state;
            let self = this;

            this.setState({
                inputDisabled: false,
                clicked: false
            });

            // Ensure persistent start time for each active bet
            if (this.state.im_in_game_1 && !this.betStartTime1) {
                this.betStartTime1 = Date.now();
            }
            if (this.state.im_in_game_2 && !this.betStartTime2) {
                this.betStartTime2 = Date.now();
            }

            let buttonProgress = setInterval(function () {
                let now = Date.now();

                // Check Slot 1 (Buy)
                if (self.betStartTime1 && self.state.im_in_game_1) {
                    let elapsedTime1 = now - self.betStartTime1;
                    if (elapsedTime1 >= 10000) {
                        self.cashOut(1);
                    }
                }

                // Check Slot 2 (Sell)
                if (self.betStartTime2 && self.state.im_in_game_2) {
                    let elapsedTime2 = now - self.betStartTime2;
                    if (elapsedTime2 >= 10000) {
                        self.cashOut(2);
                    }
                }

                let amount = self.state.amount;
                let amount2 = self.state.secondBetAmount || amount;
                let currentRate = Game['current_amount'];
                let calc1 = amount * (currentRate - 1);
                let calc2 = amount2 * (currentRate - 1);

                let updates = { showNext: false };

                // Slot 1 Button - Keep disabled during active bet, don't change text
                if (self.state.im_in_game_1 && !self.state.isCashingOut1) {
                    updates.buyDisabled = true; // Keep button disabled during 30-second window
                }

                // Slot 2 Button - Keep disabled during active bet, don't change text
                if (self.state.im_in_game_2 && !self.state.isCashingOut2) {
                    updates.sellDisabled = true; // Keep button disabled during 30-second window
                }

                if (self._isMounted) {
                    self.setState(updates);
                }
            }.bind(this), 50);

            this.buttonProgressInterval = buttonProgress;
            this.setState({ buttonProgress: this.buttonProgressInterval });
        }
    }


    checkBustedGame() {
        if (this._isMounted) {
            // Check if we have active bets within the 30-second window
            const hasActiveBet1 = this.state.im_in_game_1 && this.betStartTime1 && (Date.now() - this.betStartTime1 < 10000);
            const hasActiveBet2 = this.state.im_in_game_2 && this.betStartTime2 && (Date.now() - this.betStartTime2 < 10000);

            if (hasActiveBet1 || hasActiveBet2) {
                // console.log(`[GAME BUSTED] Game crashed but player has active bet - keeping position active`);
            } else {
                // console.log('[GAME BUSTED] Game crashed - no active bets to preserve');
            }

            // Only reset the game status, but preserve active player positions
            // Reset synchronous cashout guards
            this._cashingOut1 = false;
            this._cashingOut2 = false;

            const stateUpdate = {
                gameStatus: 'busted',
                clicked: false,
                isPlacingBet1: false,
                isPlacingBet2: false,
                buyTriggered: false,
                isCashingOut1: false,
                isCashingOut2: false
            };

            // Only reset player positions if they don't have active bets within 30-second window
            if (!hasActiveBet1) {
                stateUpdate.im_in_game_1 = false;
            }
            if (!hasActiveBet2) {
                stateUpdate.im_in_game_2 = false;
            }

            this.setState(stateUpdate);

            // Independent reset of start times and graph indicators
            if (!hasActiveBet1) {
                this.betStartTime1 = null;
                if (this.state.engine) {
                    this.state.engine.activeTrades = this.state.engine.activeTrades.filter(t => t.slot !== 1);
                }
            }
            if (!hasActiveBet2) {
                this.betStartTime2 = null;
                if (this.state.engine) {
                    this.state.engine.activeTrades = this.state.engine.activeTrades.filter(t => t.slot !== 2);
                }
            }

            // Clear resources if no active bets remain
            if (!hasActiveBet1 && !hasActiveBet2) {
                // Clear active trades
                if (this.state.engine) {
                    this.state.engine.activeTrades = [];
                }
                if (this.tradeExpiryTimers) {
                    this.tradeExpiryTimers.forEach(t => clearTimeout(t));
                    this.tradeExpiryTimers = [];
                }

                if (!this.state.holding) {
                    this.props.setMeToGame(false);
                    if (this.buttonProgressInterval) {
                        clearInterval(this.buttonProgressInterval);
                        this.buttonProgressInterval = null;
                    }
                    this.setState({ buttonProgress: null });
                    this.setDefaultButton();
                }
            }
            // If we have active bets, keep the timer running
            // The 30-second setTimeout will handle the auto-cashout
        }
    }

    isCorrectBet() {
        let { amount, payout } = this.state;

        if (!isValidNumber(amount))
            return false;

        if ((payout * 100) < 100)
            return false;

        if ((payout * 100) === 100)
            return false;

        return true;
    }

    placeBet(slot = 1) {
        if (this._isMounted) {
            let { engine } = this.state;
            engine.isHolding = false;
            if (slot === 1) {
                // Keep button text as 'Buy'
            } else {
                // Keep button text as 'Sell'
            }
            this.setBet(slot);
        }
    }

    holdBet(slot = 1) {
        if (this._isMounted) {
            let { engine } = this.state;
            engine.isHolding = true;
            if (slot === 1) {
                this.setState({ holding: true, holdingSlot: 1, im_in_game_1: false, buyDisabled: true });
            } else {
                this.setState({ holding: true, holdingSlot: 2, im_in_game_2: false, sellDisabled: true });
            }
        }
    }

    handleBuy(e) {
        if (this._isMounted) {

            let { isLogged } = this.props;

            e.preventDefault();
            e.stopPropagation();

            if (!isLogged) {
                sendNotfication("Please login to trade", 'danger', 'top-center');
                return;
            }

            if (this.state.im_in_game_1) {
                this.cashOut(1);
                return;
            }

            // Check for insufficient balance
            let currentBalance = parseFloat(this.props.credit);
            if (isNaN(currentBalance)) currentBalance = 0;

            if (parseFloat(this.state.amount) > currentBalance) {
                sendNotfication("Insufficient Balance", 'danger', 'top-center');
                return;
            }

            if (this.state.isPlacingBet1 || this.state.countdown1 !== null) return;

            // Start 1 second countdown with loader
            this.setState({ countdown1: 1, isLoadingBet1: true });
            this.countdownInterval1 = setInterval(() => {
                if (this._isMounted) {
                    if (this.state.countdown1 <= 1) {
                        clearInterval(this.countdownInterval1);
                        // Keep spinner on (isLoadingBet1: true) until handlePlay confirms entry
                        this.setState({ countdown1: null });
                        this.placeBuyOrder();
                    } else {
                        this.setState(prev => ({ countdown1: prev.countdown1 - 1 }));
                    }
                } else {
                    clearInterval(this.countdownInterval1);
                }
            }, 1000);
        }
    }

    placeBuyOrder() {
        if (this._isMounted) {
            let { gameStatus, amount, engine } = this.state;

            // Capture entry info
            const currentMult = parseFloat(Game['current_amount']) || 1.00;
            const entryTime = Date.now();
            const expiryTime = entryTime + 10000;

            const newTrade = {
                id: randomString(8),
                amount: amount,
                entryMult: currentMult,
                entryTime: entryTime,
                expiryTime: expiryTime,
                slot: 1
            };

            if (engine) {
                // We will wait for handlePlay to add the trade to engine.activeTrades
            }

            // Auto-cashout is handled by startTimerInterval — no duplicate setTimeout here

            if (gameStatus === 'waiting') {
                console.log('[BUY] Placing bet in WAITING state');
                this.placeBet(1);
            } else if (gameStatus === 'started') {
                // Initialize bet start time immediately for mid-game entry
                if (!this.betStartTime1) {
                    this.betStartTime1 = Date.now();
                    // console.log('[BUY] Bet start time set:', new Date(this.betStartTime1).toLocaleTimeString());
                }
                console.log('[BUY] Placing bet in STARTED state - 30 second timer begins');
                this.placeBet(1); // Force entry in active game
                // Start the timer interval immediately after placing bet
                setTimeout(() => {
                    if (this._isMounted && this.state.im_in_game_1) {
                        this.startTimerInterval();
                    }
                }, 100);
            } else {
                console.log('[BUY] Holding bet for next round');
                this.holdBet(1);
            }
        }
    }

    handleSell(e) {
        if (this._isMounted) {
            let { isLogged } = this.props;

            e.preventDefault();
            e.stopPropagation();

            if (!isLogged) {
                sendNotfication("Please login to trade", 'danger', 'top-center');
                return;
            }

            if (this.state.im_in_game_2) {
                this.cashOut(2);
                return;
            }

            // Check for insufficient balance
            let currentBalance = parseFloat(this.props.credit);
            if (isNaN(currentBalance)) currentBalance = 0;

            let betAmount = parseFloat(this.state.secondBetAmount || this.state.amount);

            if (betAmount > currentBalance) {
                sendNotfication("Insufficient Balance", 'danger', 'top-center');
                return;
            }

            if (this.state.isPlacingBet2 || this.state.countdown2 !== null) return;

            // Start 1 second countdown with loader
            this.setState({ countdown2: 1, isLoadingBet2: true });
            this.countdownInterval2 = setInterval(() => {
                if (this._isMounted) {
                    if (this.state.countdown2 <= 1) {
                        clearInterval(this.countdownInterval2);
                        // Keep spinner on (isLoadingBet2: true) until handlePlay confirms entry
                        this.setState({ countdown2: null });
                        this.placeSellOrder();
                    } else {
                        this.setState(prev => ({ countdown2: prev.countdown2 - 1 }));
                    }
                } else {
                    clearInterval(this.countdownInterval2);
                }
            }, 1000);
        }
    }

    placeSellOrder() {
        if (this._isMounted) {
            let { gameStatus, secondBetAmount, amount, engine } = this.state;

            // Capture entry info
            const currentMult = parseFloat(Game['current_amount']) || 1.00;
            const entryTime = Date.now();
            const expiryTime = entryTime + 10000;

            const newTrade = {
                id: randomString(8),
                amount: secondBetAmount || amount,
                entryMult: currentMult,
                entryTime: entryTime,
                expiryTime: expiryTime,
                slot: 2
            };

            if (engine) {
                // We will wait for handlePlay to add the trade to engine.activeTrades
            }

            // Auto-cashout is handled by startTimerInterval — no duplicate setTimeout here

            if (gameStatus === 'waiting') {
                console.log('[SELL] Placing bet in WAITING state');
                this.placeBet(2);
            } else if (gameStatus === 'started') {
                // Initialize bet start time immediately for mid-game entry
                if (!this.betStartTime2) {
                    this.betStartTime2 = Date.now();
                    // console.log('[SELL] Bet start time set:', new Date(this.betStartTime2).toLocaleTimeString());
                }
                console.log('[SELL] Placing bet in STARTED state - 30 second timer begins');
                this.placeBet(2); // Force entry in active game
                // Start the timer interval immediately after placing bet
                setTimeout(() => {
                    if (this._isMounted && this.state.im_in_game_2) {
                        this.startTimerInterval();
                    }
                }, 100);
            } else {
                console.log('[SELL] Holding bet for next round');
                this.holdBet(2);
            }
        }
    }

    hotkeyChange() {
        if (this._isMounted) {
            if (this.state.hotkey === "OFF") {
                User['denied_hotkey'] = false;
                storage.setKey("hotkey", 'ON');
                this.setState({ hotkey: "ON" })
            }
            else {
                storage.setKey("hotkey", 'OFF');
                this.setState({ hotkey: "OFF" })
            }
        }
    }

    handleHotKey(e) {
        if (this._isMounted) {
            if (User['denied_hotkey']) {
                User['denied_hotkey'] = false;
                storage.setKey('hotkey', "OFF");
                this.setState({ hotkey: 'OFF' })
            }

            if (storage.getKey('hotkey') === 'ON') {
                var char = e.which || e.keyCode;
                if (char === 98) {
                    this.handleBuy(e);
                }
                if (char === 102) {
                    var calc = parseFloat(this.state.payout * 2);
                    var max = Math.max(1.00, calc);
                    this.setState({ payout: max.toFixed(2) })
                }
                if (char === 101) {
                    var calc = parseFloat(this.state.payout / 2);
                    var max = Math.max(1.00, calc);
                    this.setState({ payout: max.toFixed(2) })
                }

                this.handleInputChange(e);
            }
        }
    }

    setMax = (e) => {
        e.preventDefault();
        var max = 200
        if (max === null) return;

        this.setState({ amount: forceSatoshiFormat(max), secondBetAmount: forceSatoshiFormat(max) });
        storage.setKey('lam', forceSatoshiFormat(max));
        storage.setKey('lam2', forceSatoshiFormat(max));
    };

    setMin = (e) => {
        e.preventDefault();
        this.setState({ amount: '10.00', secondBetAmount: '10.00' });
        storage.setKey('lam', '10.00');
        storage.setKey('lam2', '10.00');
    };

    multi = (e) => {
        var max = 50
        this.setState({ amount: forceSatoshiFormat(max), secondBetAmount: forceSatoshiFormat(max) });
        storage.setKey('lam', forceSatoshiFormat(max));
        storage.setKey('lam2', forceSatoshiFormat(max));
    }

    devide = (e) => {
        var max = 100
        max = Math.max(max, 0.00000010)
        this.setState({ amount: forceSatoshiFormat(max), secondBetAmount: forceSatoshiFormat(max) });
        storage.setKey('lam', forceSatoshiFormat(max));
        storage.setKey('lam2', forceSatoshiFormat(max));
    }

    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    setActiveTab(tab) {
        this.setState({ activeTab: tab });
    }

    setActiveTab2(tab) {
        this.setState({ activeTab2: tab });
    }

    handleBetAmountClick = (amount, section) => {
        if (section === 'first') {
            this.setState({ amount: amount, secondBetAmount: amount });
            storage.setKey('lam', amount);
            storage.setKey('lam2', amount);
        } else if (section === 'second') {
            this.setState({ secondBetAmount: amount });
            storage.setKey('lam2', amount);
        }
    };

    incrementAmount = (section) => {
        if (section === 'first') {
            this.setState(prevState => {
                const next = Math.min(10000, prevState.amount + 10);
                storage.setKey('lam', next);
                storage.setKey('lam2', next);
                return { amount: next, secondBetAmount: next };
            });
        } else if (section === 'second') {
            this.setState(prevState => {
                const next = Math.min(10000, prevState.secondBetAmount + 10);
                storage.setKey('lam2', next);
                return { secondBetAmount: next };
            });
        }
    };

    decrementAmount = (section) => {
        if (section === 'first') {
            this.setState(prevState => {
                const next = Math.max(10, prevState.amount - 10);
                storage.setKey('lam', next);
                storage.setKey('lam2', next);
                return { amount: next, secondBetAmount: next };
            });
        } else if (section === 'second') {
            this.setState(prevState => {
                const next = Math.max(10, prevState.secondBetAmount - 10);
                storage.setKey('lam2', next);
                return { secondBetAmount: next };
            });
        }
    };

    incrementPayout = () => {
        this.setState(prevState => {
            const newPayout = Math.min(1000000, parseFloat(prevState.payout) + 0.01).toFixed(2);
            storage.setKey('odd', newPayout);
            return { payout: newPayout };
        });
    };

    decrementPayout = () => {
        this.setState(prevState => {
            const newPayout = Math.max(1.01, parseFloat(prevState.payout) - 0.01).toFixed(2);
            storage.setKey('odd', newPayout);
            return { payout: newPayout };
        });
    };

    renderWinNotification() {
        if (!this.state.showWinNotification) return null;

        return (
            <div className="win-notification-overlay" onClick={() => this.setState({ showWinNotification: false })}>
                <div className="win-content-horizontal animated bounceIn">
                    <div className="win-shimmer"></div>
                    <div className="confetti-container">
                        {[...Array(12)].map((_, i) => (
                            <div key={i} className={`confetti-piece confetti-${i}`}></div>
                        ))}
                    </div>
                    <div className="win-sparkles"></div>
                    <div className="win-row">
                        <div className="win-trophy-small">
                            <i className="mdi mdi-trophy-variant"></i>
                        </div>
                        <div className="win-label">WON!</div>
                        <div className="win-amount-horizontal">
                            <span className="currency">KES</span>
                            <span className="value">{this.state.winAmount}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let { amount, inputDisabled, payout, buyDisabled, buyButtonText, sellButtonText, sellDisabled, countdown1, countdown2, im_in_game_1, im_in_game_2, isLoadingBet1, isLoadingBet2 } = this.state;
        let { isLogged } = this.props;

        if (amount === "NaN") amount = 50.00;

        return (
            <div className="betAuto-tab" id="betbox-ui">
                {this.renderWinNotification()}
                <div className="betAuto-tab-col">
                    <div className="bet-controlar">
                        {/* Amount Section */}
                        <div className="bet-block">
                            <span className="bet-block-label">Trade Amount (KES)</span>
                            <div className="form-spinner">
                                <div
                                    className="spinner-btn"
                                    onClick={() => this.decrementAmount('first')}
                                >
                                    <i className="mdi mdi-minus" />
                                </div>
                                <input
                                    type="number"
                                    name="amount"
                                    value={amount}
                                    onChange={this.handleInputChange}
                                    id="spinner1"
                                />
                                <div
                                    className="spinner-btn"
                                    onClick={() => this.incrementAmount('first')}
                                >
                                    <i className="mdi mdi-plus" />
                                </div>
                            </div>
                            <div className="bets-opt-list">
                                {[100, 200, 500, 5000].map((val) => (
                                    <button
                                        key={val}
                                        className="btn-opt"
                                        onClick={() => this.handleBetAmountClick(val, 'first')}
                                    >
                                        {val}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Action Bu ttons */}
                        <div className="button-block row">
                            <div className="col-md-12 col-6 pr-0">
                                <button
                                    className={`btn-bet-premium btn-buy-premium ${im_in_game_1 ? 'im-in-game' : ''}`}
                                    disabled={inputDisabled || buyDisabled || countdown1 !== null || isLoadingBet1}
                                    onClick={this.handleBuy}
                                >
                                    {isLoadingBet1 ? (
                                        <span> <i className="mdi mdi-loading mdi-spin font-24" /></span>
                                    ) : (
                                        <>
                                            <span className="btn-bet-text d-flex align-items-center justify-content-center">
                                                {countdown1 !== null ? `Wait ${countdown1}s` : (
                                                    <>
                                                        <i className="mdi mdi-arrow-up-drop-circle-outline"></i>
                                                        {/* {buyButtonText} */}
                                                    </>
                                                )}
                                            </span>
                                        </>
                                    )}
                                </button>
                            </div>
                            <div className="col-md-12 col-6 pr-0">
                                <button
                                    className={`btn-bet-premium btn-sell-premium ${im_in_game_2 ? 'im-in-game' : ''}`}
                                    disabled={inputDisabled || sellDisabled || countdown2 !== null || isLoadingBet2}
                                    onClick={this.handleSell}
                                >
                                    {isLoadingBet2 ? (
                                        <span> <i className="mdi mdi-loading mdi-spin font-24" /></span>
                                    ) : (
                                        <>
                                            <span className="btn-bet-text d-flex align-items-center justify-content-center">
                                                {countdown2 !== null ? `Wait ${countdown2}s` : (
                                                    <>
                                                        <i className="mdi mdi-arrow-down-drop-circle-outline"></i>
                                                        {/* {sellButtonText} */}
                                                    </>
                                                )}
                                            </span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="mt-auto w-100 mt-2" style={{ display: 'flex', justifyContent: 'center' }}>
                        <Menus />
                    </div>
                </div>
            </div>
        );
    }
}

class HotKey extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            effect: 'pulse'
        };
    }

    toggleModal = (e) => {
        if (e !== undefined)
            e.preventDefault();

        this.setState({ show: !this.state.show, effect: !this.state.show ? 'zoomIn' : 'zoomOut' });
    };

    render() {
        return (
            <>
                <button className={'btn btn-xs stc mt-1 pl-1'} onClick={e => this.toggleModal(e)}>
                    <i className={'cp mdi mdi-information text-info font-15'} />
                </button>
                <Modal
                    size="md"
                    centered={true}
                    backdrop="static"
                    show={this.state.show}
                    onHide={this.toggleModal}
                    aria-labelledby="help-lg-modal"
                    className={"animated " + this.state.effect}
                >
                    <Modal.Header>
                        Hot Keys
                        <button type="button" className="close p-2" onClick={e => this.toggleModal(e)}>
                            <i className={'mdi mdi-close'} />
                        </button>
                    </Modal.Header>
                    <Modal.Body closeButton className="modal-helper text-center">
                        <Row className="shortcut-helper">
                            <Col sm="12">
                                <span className="badge badge-soft-danger">B</span>
                                <i className="mdi mdi-arrow-right align-middle"></i>
                                <span className="badge badge-soft-secondary"> BET</span>
                            </Col>
                            <Col sm="12" className="my-2">
                                <span className="badge badge-soft-danger"> E</span>
                                <i className="mdi mdi-arrow-right align-middle"></i>
                                <span className="badge badge-soft-secondary"> HALF PAYOUT</span>
                            </Col>
                            <Col sm="12">
                                <span className="badge badge-soft-danger"> F</span>
                                <i className="mdi mdi-arrow-right align-middle"></i>
                                <span className="badge badge-soft-secondary"> DOUBLE PAYOUT</span>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

ManualBet.propTypes = {
    coin: PropTypes.string,
    im_in_game: PropTypes.bool,
    credit: PropTypes.string
};

const mapStateToProps = state => ({
    coin: state.items.coin,
    im_in_game: false,
    credit: state.items.credit
});

export default connect(mapStateToProps, { gameCoin, setWinnerText, setMeToGame, setWallet })(ManualBet);